import React from 'react';
import { ThomasAdvertiser, ThomasAdvertiserReduced } from 'models/interfaces';
import memoize from 'memoize-one';
import './ThomasAdvertisersList.scss';
import { TableRow, SortOptions } from 'models/interfaces/Table';
import {
  createAdvertiserRow,
  makeAdvertiserHeadings,
  createAdvertiserByProductRow,
  makeAdvertiserByProductHeadings
} from './ThomasAdvertisersListConfig';
import Table from '../Table/TableComponent';

export interface ThomasAdvertisersListProps {
  thomasAdvertisers?: ThomasAdvertiser[];
  thomasAdvertisersReduced?: ThomasAdvertiserReduced[];
  updateCache: any;
  updatePage?: (from: number, size: number) => void;
  sortOptions: SortOptions;
  productId?: number;
  size?: number;
  from?: number;
  resultsCount?: number;
}

const ThomasAdvertisersList: React.FunctionComponent<ThomasAdvertisersListProps> = ({
  thomasAdvertisers,
  thomasAdvertisersReduced,
  updateCache,
  updatePage,
  sortOptions,
  productId,
  size,
  from,
  resultsCount
}) => {
  const advertiserHeadings = productId
    ? makeAdvertiserByProductHeadings(sortOptions)
    : makeAdvertiserHeadings(sortOptions);
  const buildRenderDataFromProps = (thomasAdvertisers: any[]) => {
    return thomasAdvertisers.reduce<[Map<string, any>, TableRow[]]>(
      ([map, rows], x) => {
        // shallow copy thomas Advertiser to save from disappearing due to no-cache
        const copy: ThomasAdvertiser = { ...x };
        // add copy to map
        map.set(copy.tgrams_id, copy);
        // create template tr and add to array
        const tr = productId
          ? createAdvertiserByProductRow(copy, productId)
          : createAdvertiserRow(copy);
        rows.push(tr);

        return [map, rows];
      },
      [new Map<string, ThomasAdvertiser>(), new Array<TableRow>()]
    );
  };

  let advertiserDisplayRows: any = [];

  if (
    thomasAdvertisersReduced !== undefined &&
    Array.isArray(thomasAdvertisersReduced) &&
    thomasAdvertisersReduced.length > 0
  ) {
    // memoize render data
    const memoizedRenderData = memoize(buildRenderDataFromProps);
    const [advertisersMap, advertiserRows] = memoizedRenderData(thomasAdvertisersReduced);
    advertiserDisplayRows = advertiserRows;
  }

  return (
    <Table
      headings={advertiserHeadings}
      data={advertiserDisplayRows}
      onSort={(sortKey: string, sortDirection: string) => {
        const newSortOptions: SortOptions = Object.assign({}, sortOptions);
        Object.keys(newSortOptions).forEach(
          (key: string): void => {
            if (key === sortKey) {
              newSortOptions[key] = sortDirection;
            } else {
              newSortOptions[key] = 'DESC';
            }
          }
        );
        let data: any;
        if (productId) {
          data =
            productId == 1
              ? {
                  advertisersByPVSPageCache: {
                    sortOptions: newSortOptions,
                    activeSort: {
                      sortKey,
                      sortDirection
                    }
                  }
                }
              : {
                  advertisersByPointsPageCache: {
                    sortOptions: newSortOptions,
                    activeSort: {
                      sortKey,
                      sortDirection
                    }
                  }
                };
        } else {
          data = {
            advertisersPageCache: {
              productId: productId,
              sortOptions: newSortOptions,
              activeSort: {
                sortKey,
                sortDirection
              }
            }
          };
        }
        updateCache(data);
      }}
      from={from}
      size={size}
      updatePage={updatePage}
      resultsCount={resultsCount}
    />
  );
};

export default ThomasAdvertisersList;
